import { IconBase } from "./iconBase.js";
import { jsx } from "@emotion/react/jsx-runtime";
//#region src/windows.tsx
var Windows = ({ ...rest }) => /* @__PURE__ */ jsx(IconBase, {
	viewBox: "0 0 24 24",
	...rest,
	children: /* @__PURE__ */ jsx("path", {
		d: "M21 21L11.2549 19.5889V12.4961H21V21ZM10.2627 19.4443L3 18.3926V12.4961H10.2627V19.4443ZM10.2627 11.5039H3V5.60645L10.2627 4.55469V11.5039ZM21 11.5039H11.2549V4.41113L21 3V11.5039Z",
		fill: "currentColor"
	})
});
//#endregion
export { Windows };
